<app-configuration-datasource *ngIf="dataSourceInstance" [editEnabled]="false" [dataSourceInstance]="dataSourceInstance" [duplicateEnabled]="false"
  [highlightSelected]="false" [hideRoot]="true" (onTreeNodeSelect)="onTreeNodeSelect($event)" [alwaysSelect]="true"></app-configuration-datasource>

